import React, { lazy } from 'react'
import { RouteObject, Navigate } from 'react-router-dom'
import useUser from '../../../hooks/useUser'

const TenantSetupListing = lazy(
    () => import('../components/TenantSetupListing')
)
const TenantSetupHub = lazy(() => import('../components/TenantSetupHub'))

const RootRedirect: React.FC = () => {
    const { currentUser } = useUser()
    const tenantId = currentUser?.tenantId || currentUser?.tenant?.id
    
    if (tenantId) {
        return <Navigate to={`/tenants/${tenantId}`} replace />
    }
    return <TenantSetupListing />
}

export const HomePageRoute: RouteObject = {
    path: '',
    element: <RootRedirect />,
}

export const TenantSetupListingRoute: RouteObject = {
    path: 'manage-tenants',
    element: <TenantSetupListing />,
}

/**
 * Keeps old links and bookmarks working after the rename from
 * /tenant-setup-list.
 */
export const TenantSetupListingLegacyRoute: RouteObject = {
    path: 'tenant-setup-list',
    element: <Navigate to="/manage-tenants" replace />,
}

/** Full setup hub — at /tenants/:tenantId/setup (untouched internally) */
export const TenantSetupHubRoute: RouteObject = {
    path: 'tenants/:tenantId/setup',
    element: <TenantSetupHub />,
}


